import i18n from 'i18next';

import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
};

// Synchronous init — no plugins, no async. Our custom useT hook handles React reactivity.
i18n.init({
  resources,
  fallbackLng: 'en',
  lng: 'es',
  initImmediate: false, // Force synchronous initialization
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
